import React from 'react';
import {
    Route,
    Redirect
  } from "react-router-dom";

// Private Routes -> https://tylermcginnis.com/react-router-protected-routes-authentication/

export default ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
      rest.session === true
        ? <Component {...props} />
        : ( rest.session == null ? null : <Redirect to='/login' /> )  
    )} />
)